import type { ReactNode } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const ImagePlaceholderContainer = ({ children }: { children: ReactNode }) => (
    <Flex
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="100%"
        background={`linear-gradient(180deg, ${colorsPalettes.carbon[25]} 0%, ${colorsPalettes.carbon[100]} 100%)`}
    >
        {children}
    </Flex>
);
